import axios from '@/plugins/axios'
import { Trans } from '@/plugins/i18n/translationHandler'
import { mapActions } from 'vuex'
import moment from 'moment'
export default {
    data() {
        return {
            loading: true,
            inIframe: false,
        }
    },
    watch: {
        '$i18n.locale': function (newLocale, oldLocale) {
          if (newLocale !== oldLocale)
            this.fetchLists();
        }
    },
    methods: {
        ...mapActions('regions', ['setRegions']),
        ...mapActions('dates', ['setYears', 'setMonthRange']),
        ...mapActions('periods', ['setPeriods']),
        ...mapActions('markets', ['setMarkets']),
        async fetchLists() {
            Promise.all([this.fetchRegions(), this.fetchYears(), this.fetchMarkets()])
                .then((res) => {
                    // Handle Region response
                    this.setRegions(res[0].data);
                    // Handle markets response
                    this.setMarkets(res[2].data);
                    // Handle Year response
                    this.setYears(this.computeYears(moment(res[1].data.min).year(), moment(res[1].data.max).year()))
                    this.setMonthRange(this.computeRange(res[1].data.min, res[1].data.max))
                })
                .finally(() => {
                    this.loading = false
                })
        },
        fetchRegions() {   
            return axios.post(`lists/regions`, {
                language: this.$i18n.locale,
                ...this.$utils.getDestinationParams(),
            })
        },
        fetchMarkets() {
            return axios.post(`hesta/GetCountriesForPeriod`, {
                language: this.$i18n.locale,
            })
        },
        fetchYears() {
            return axios.get(`hesta/GetPeriodRange`)
        },
        fetchPeriods() {
            return axios.get(`lists/periods`)
        },
        computeYears(min, max) {
            const years = []
            for (let i = min; i <= max; i++) years.push(i)
            return years
        },
        computeRange(min, max) {
            return {
                minDate: moment(min).format('MM-DD-YYYY'),
                maxDate: moment(max).format('MM-DD-YYYY'),
            }
        },
        stopLoading() {
            this.loading = false
        },
    },
}